import { adminPartnerQueryKeys as e } from "./useAdminPartnerQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminPartnersApi as r } from "@maat/api-main";
//#region src/partners/admin/useBulkCreatePartnerLinksMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ partnerId: e, data: t }) => r.createLinksBulk(e, t),
		onSuccess: (t, { partnerId: n }) => {
			i.invalidateQueries({ queryKey: e.detail(n) });
		}
	});
};
//#endregion
export { i as useBulkCreatePartnerLinksMutation };
